import Swal from "sweetalert2";

const BRAND = "#14251F";
const BRAND_LIGHT = "#FFD1A0";
const ACCENT = "#D48C1E";
const DANGER = "#dc2626";

const baseToast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 2500,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener("mouseenter", Swal.stopTimer);
    toast.addEventListener("mouseleave", Swal.resumeTimer);
  },
});

/**
 * Show a confirm dialog. Returns true if user confirmed.
 * await confirmDialog({ title, text, confirmText, danger })
 */
export const confirmDialog = async ({
  title = "Are you sure?",
  text = "",
  confirmText = "Yes",
  cancelText = "Cancel",
  danger = false,
  icon = "question",
} = {}) => {
  const result = await Swal.fire({
    title,
    text,
    icon,
    showCancelButton: true,
    confirmButtonText: confirmText,
    cancelButtonText: cancelText,
    confirmButtonColor: danger ? DANGER : BRAND,
    cancelButtonColor: "#6b7280",
    reverseButtons: true,
    focusCancel: true,
  });
  return result.isConfirmed;
};

/** Confirm a destructive action (red confirm button). */
export const confirmDelete = ({
  title = "Delete?",
  text = "This action cannot be undone.",
  confirmText = "Yes, delete it",
} = {}) =>
  confirmDialog({
    title,
    text,
    confirmText,
    danger: true,
    icon: "warning",
  });

/** Success toast (top-right). */
export const successToast = (text) =>
  baseToast.fire({ icon: "success", title: text });

/** Error toast. */
export const errorToast = (text) =>
  baseToast.fire({ icon: "error", title: text });

/** Info toast. */
export const infoToast = (text) =>
  baseToast.fire({ icon: "info", title: text });

/** Full-modal success (use sparingly, e.g. after a save). */
export const successModal = ({ title = "Success", text = "" } = {}) =>
  Swal.fire({
    title,
    text,
    icon: "success",
    confirmButtonColor: BRAND,
    confirmButtonText: "OK",
  });

/** Full-modal error. */
export const errorModal = ({ title = "Error", text = "" } = {}) =>
  Swal.fire({
    title,
    text,
    icon: "error",
    confirmButtonColor: BRAND,
    confirmButtonText: "OK",
  });

export { Swal };
export const BRAND_COLORS = { BRAND, BRAND_LIGHT, ACCENT, DANGER };
